/* Kitpup theme — small, no dependencies */
(() => {
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';

  /* Product form: add selected pack + optional add-on in one request */
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const fid = form.getAttribute('id');
    const btns = document.querySelectorAll(`[form="${fid}"][type=submit], #${fid} [type=submit]`);
    const err = form.querySelector('[data-error]');
    const totalEls = document.querySelectorAll(`[data-total="${fid}"]`);
    const nameEls = document.querySelectorAll(`[data-pack-name="${fid}"]`);
    const money = (cents) => {
      const cfg = form.closest('[data-money-format]');
      const fmt = (cfg && cfg.dataset.moneyFormat) || '${{amount}}';
      const amount = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount\s*\}\}/, amount);
    };
    const update = () => {
      const pk = form.querySelector('input[name=pack]:checked');
      const v = pk || form.querySelector('input[name=id]:checked') || form.querySelector('[name=id]');
      const a = form.querySelector('input[name=addon]');
      const al = a && a.closest('[data-hide-for]');
      if (al) {
        const hide = al.dataset.hideFor !== '0' && v && v.dataset.pos === al.dataset.hideFor;
        al.hidden = hide;
        if (hide) a.checked = false;
      }
      let cents = Number(v && v.dataset.price || 0);
      if (a && a.checked) cents += Number(a.dataset.price || 0);
      totalEls.forEach((el) => { el.textContent = money(cents); });
      if (v && v.dataset.title) nameEls.forEach((el) => { el.textContent = v.dataset.title + (a && a.checked ? ' + add-on' : ''); });
    };
    form.addEventListener('change', update);
    update();

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const fd = new FormData(form);
      const pack = form.querySelector('input[name=pack]:checked');
      const items = [{ id: Number(fd.get('id')), quantity: pack ? Number(pack.dataset.qty) || 1 : 1 }];
      if (pack && pack.dataset.extras) pack.dataset.extras.split(',').filter(Boolean).forEach((x) => items.push({ id: Number(x), quantity: 1 }));
      if (fd.get('addon')) items.push({ id: Number(fd.get('addon')), quantity: 1 });
      btns.forEach((b) => b.setAttribute('aria-busy', 'true'));
      if (err) err.textContent = '';
      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        window.location.href = root + ((form.closest('[data-after]') || form).dataset.after === 'checkout' ? 'checkout' : 'cart');
      } catch (ex) {
        if (err) err.textContent = ex.message;
        btns.forEach((b) => b.removeAttribute('aria-busy'));
      }
    });
  });

  /* Gallery thumbnails */
  document.querySelectorAll('[data-gallery]').forEach((wrap) => {
    const track = wrap.querySelector('.gallery');
    const thumbs = wrap.querySelectorAll('[data-thumb]');
    const count = track.children.length;
    const go = (i) => track.scrollTo({ left: track.clientWidth * ((i + count) % count), behavior: 'smooth' });
    const cur = () => Math.round(track.scrollLeft / track.clientWidth);
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    const prev = wrap.querySelector('[data-prev]'), next = wrap.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', () => go(cur() - 1));
    if (next) next.addEventListener('click', () => go(cur() + 1));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach((t, j) => t.setAttribute('aria-current', j === i ? 'true' : 'false'));
        const c = wrap.querySelector('[data-count]'); if (c) c.textContent = i + 1;
        const at = thumbs[i]; if (at && at.parentElement.scrollWidth > at.parentElement.clientWidth) at.parentElement.scrollTo({ left: at.offsetLeft - at.parentElement.offsetLeft, behavior: 'smooth' });
      });
    }, { passive: true });
  });

  /* Sticky add-to-cart: show once the main button scrolls out of view */
  const sticky = document.querySelector('[data-sticky-atc]');
  const anchor = document.querySelector('[data-atc-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => {
      sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
    }).observe(anchor);
  }

  /* Cart quantity buttons */
  document.querySelectorAll('[data-qty]').forEach((q) => {
    const input = q.querySelector('input');
    q.querySelectorAll('button').forEach((b) => b.addEventListener('click', () => {
      input.value = Math.max(0, Number(input.value) + Number(b.dataset.step));
      input.form && input.form && input.form.requestSubmit(input.form.querySelector('[data-cart-update]'));
    }));
  });

  /* Rotating review card */
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-rotator]').forEach((r) => {
    const slides = r.querySelectorAll('[data-slide]');
    const dots = r.querySelectorAll('[data-dot]');
    if (slides.length < 2) return;
    let i = 0, t;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, j) => s.classList.toggle('is-active', j === i));
      dots.forEach((d, j) => d.setAttribute('aria-current', j === i ? 'true' : 'false'));
    };
    const play = () => { if (!still) t = setInterval(() => go(i + 1), Number(r.dataset.interval) || 5000); };
    dots.forEach((d, j) => d.addEventListener('click', () => { clearInterval(t); go(j); play(); }));
    r.addEventListener('mouseenter', () => clearInterval(t));
    r.addEventListener('mouseleave', () => { clearInterval(t); play(); });
    play();
  });

  /* Muted videos: load and play only while on screen */
  const vids = document.querySelectorAll('.ugc-strip video, .ps__media video, .media video[muted], .gallery__video');
  if (vids.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((ens) => ens.forEach((en) => {
      const v = en.target;
      if (en.isIntersecting && !still) { v.muted = true; v.play().catch(() => {}); } else { v.pause(); }
    }), { rootMargin: '200px 0px' });
    vids.forEach((v) => { v.muted = true; v.removeAttribute('autoplay'); io.observe(v); });
  }

  /* Reviews: filter chips + load more */
  document.querySelectorAll('[data-reviews]').forEach((w) => {
    const cards = [...w.querySelectorAll('[data-tags]')];
    const chips = w.querySelectorAll('[data-filter]');
    const more = w.querySelector('[data-more]');
    const per = Number(w.dataset.perPage) || 6;
    let f = 'all', n = per;
    const draw = () => {
      const match = cards.filter((c) => f === 'all' || c.dataset.tags.split(' ').includes(f));
      cards.forEach((c) => { c.hidden = true; });
      match.slice(0, n).forEach((c) => { c.hidden = false; });
      if (more) more.hidden = match.length <= n;
    };
    chips.forEach((c) => c.addEventListener('click', () => {
      f = c.dataset.filter; n = per;
      chips.forEach((x) => x.setAttribute('aria-pressed', x === c ? 'true' : 'false'));
      draw();
    }));
    if (more) more.addEventListener('click', () => { n += per; draw(); });
  });

  /* Collection: filter chips + sort */
  document.querySelectorAll('[data-collection]').forEach((w) => {
    const items = [...w.querySelectorAll('[data-ctags]')];
    const count = w.querySelector('[data-ccount]');
    const empty = w.querySelector('[data-cempty]');
    w.querySelectorAll('[data-cfilter]').forEach((c, _, all) => c.addEventListener('click', () => {
      const f = c.dataset.cfilter;
      all.forEach((x) => x.setAttribute('aria-pressed', x === c ? 'true' : 'false'));
      let n = 0;
      items.forEach((it) => { const show = f === 'all' || it.dataset.ctags.split(' ').includes(f); it.hidden = !show; if (show) n++; });
      if (count) count.textContent = n;
      if (empty) empty.hidden = n > 0;
    }));
    const sort = w.querySelector('[data-csort]');
    if (sort) sort.addEventListener('change', () => {
      const u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u;
    });
  });
})();
